import gameIds from '../data/GameIds';
import { persistStateTypes } from '../../reducers/persistStateReducer';
import readBucketData from './bucketsMigration';

export const initialState = {
  curiosoItems: [],
  verion: 1,
};

let items;
let itemExists;

const itemsReducer = (state = initialState, action) => {
  if (action.gameId !== gameIds.METAGAME) {
    return state;
  }
  switch (action.type) {
    case 'ADD_CURIOSO_ITEM':
      items = Object.assign([], state.curiosoItems);
      itemExists = items.filter(item => item.name === action.payload.item.name);
      if (itemExists.length === 0) {
        items.unshift(action.payload.item);
      }
      return {
        ...state,
        curiosoItems: items,
      };
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE_ALL:
      return {
        ...state,
        curiosoItems: readBucketData(
          state,
          action,
          'curiosoItems',
          gameIds.METAGAME_CURIOSO_ITEMS,
          true,
        ),
      };

    default:
      return state;
  }
};

export default itemsReducer;
